// ============================================================
// Hirafi — Module devis : hook mode invité
//
// Gère un brouillon de devis 100% côté client (localStorage).
// Aucune requête Supabase n'est effectuée.
// ============================================================

import { useState, useEffect, useCallback } from "react";
import type { StandaloneDevisFormData } from "../types";
import { saveGuestDraft, loadGuestDraft, clearGuestDraft } from "../lib/storage";
import { defaultValidUntil } from "../lib/calculations";

const emptyForm = (): StandaloneDevisFormData => ({
  artisan: { name: "", email: "", phone: "", address: "", activity: "" },
  client: { name: "", email: "", phone: "", address: "" },
  title: "",
  description: "",
  lineItems: [],
  totalAmount: 0,
  currency: "DZD",
  validUntil: defaultValidUntil(),
  estimatedDelay: undefined,
  notes: undefined,
});

export function useGuestDevis() {
  const [draft, setDraft] = useState<StandaloneDevisFormData>(() => {
    return loadGuestDraft() ?? emptyForm();
  });

  // Auto-save dans localStorage à chaque changement
  useEffect(() => {
    saveGuestDraft(draft);
  }, [draft]);

  const update = useCallback((partial: Partial<StandaloneDevisFormData>) => {
    setDraft((prev) => ({ ...prev, ...partial }));
  }, []);

  const reset = useCallback(() => {
    clearGuestDraft();
    setDraft(emptyForm());
  }, []);

  const isEmpty =
    !draft.title &&
    !draft.artisan.name &&
    !draft.client.name &&
    draft.lineItems.length === 0;

  return { draft, update, reset, isEmpty };
}
